import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=987defc0&"
import script from "./Home.vue?vue&type=script&defer=true&lang=js&"
export * from "./Home.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports